import { AxiosResponse, isAxiosError } from 'axios';

import { Subscription } from '@videoblocks/subscription-service-client';

import { legacySubscriptionApi } from './subscriptionServiceConfig';

const getByLegacySubscriptionId = async (legacySubscriptionId: number): Promise<Subscription | null> => {
    try {
        const response = (await legacySubscriptionApi.getLegacySubscriptionBySubscriptionId({
            legacySubscriptionId,
        })) as AxiosResponse<Subscription>;
        return response.data;
    } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};

export const LegacySubscriptionApi = { getByLegacySubscriptionId };
